"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.StaticAssets = void 0;
var Logo = __importStar(require("./../../svg/logo.svg"));
var MainImage = __importStar(require("./../../images/img-main.jpg"));
var ClientsImage = __importStar(require("./../../images/img-klients.jpg"));
var BrandsImage = __importStar(require("./../../images/img-brends.jpg"));
var Image_1 = __importStar(require("./../../images/img-1.jpg"));
var Image_2 = __importStar(require("./../../images/img-2.jpg"));
var Image_3 = __importStar(require("./../../images/img-3.jpg"));
var Image_4 = __importStar(require("./../../images/img-4.jpg"));
var Image_5 = __importStar(require("./../../images/img-5.jpg"));
var Image_6 = __importStar(require("./../../images/img-6.jpg"));
var Image_7 = __importStar(require("./../../images/img-7.jpg"));
var Image_8 = __importStar(require("./../../images/img-8.jpg"));
var Image_9 = __importStar(require("./../../images/img-9.jpg"));
var Image_10 = __importStar(require("./../../images/img-10.jpg"));
var Image_11 = __importStar(require("./../../images/img-11.jpg"));
var Image_12 = __importStar(require("./../../images/img-12.jpg"));
var Image_13 = __importStar(require("./../../images/img-13.jpg"));
var Image_15 = __importStar(require("./../../images/img-15.jpg"));
var Image_16 = __importStar(require("./../../images/img-16.jpg"));
var Image_17 = __importStar(require("./../../images/img-17.jpg"));
var Image_18 = __importStar(require("./../../images/img-18.jpg"));
var Image_19 = __importStar(require("./../../images/img-19.jpg"));
var Image_20 = __importStar(require("./../../images/img-20.jpg"));
var Image_21 = __importStar(require("./../../images/img-21.jpg"));
var Image_22 = __importStar(require("./../../images/img-22.jpg"));
var Image_23 = __importStar(require("./../../images/img-23.jpg"));
var Image_24 = __importStar(require("./../../images/img-24.jpg"));
var Image_25 = __importStar(require("./../../images/img-25.jpg"));
var Image_26 = __importStar(require("./../../images/img-26.jpg"));
var Image_27 = __importStar(require("./../../images/img-27.jpg"));
var Image_28 = __importStar(require("./../../images/img-28.jpg"));
var Image_29 = __importStar(require("./../../images/img-29.jpg"));
var Image_30 = __importStar(require("./../../images/img-30.jpg"));
var Image_31 = __importStar(require("./../../images/img-31.jpg"));
var Image_32 = __importStar(require("./../../images/img-32.jpg"));
var Image_33 = __importStar(require("./../../images/img-33.jpg"));
var Image_Obogrev_Morozilnikov = __importStar(require("./../../images/obogrev-morozilnikov.jpg"));
var Image_MK = __importStar(require("./../../images/img-mk.jpg"));
var Image_Storage_Tank = __importStar(require("./../../images/obogrev-rez.jpg"));
var Image_Clients_2 = __importStar(require("./../../images/img-klients2.jpg"));
var Image_Brands_2 = __importStar(require("./../../images/img-brends2.jpg"));
var Image_Clients_3 = __importStar(require("./../../images/img-klients3.jpg"));
var Image_Brands_3 = __importStar(require("./../../images/img-brends3.jpg"));
var Image_Pipes = __importStar(require("./../../images/obogrev-trub.jpg"));
var NoImage = __importStar(require("./../../images/no-image.png"));
var StaticAssets = /** @class */ (function () {
    function StaticAssets() {
    }
    StaticAssets.prototype.run = function () {
        return [
            Logo,
            MainImage,
            ClientsImage,
            BrandsImage,
            Image_1,
            Image_2,
            Image_3,
            Image_4,
            Image_5,
            Image_6,
            Image_7,
            Image_8,
            Image_9,
            Image_10,
            Image_11,
            Image_12,
            Image_13,
            Image_15,
            Image_16,
            Image_17,
            Image_18,
            Image_19,
            Image_20,
            Image_21,
            Image_22,
            Image_23,
            Image_24,
            Image_25,
            Image_26,
            Image_27,
            Image_28,
            Image_29,
            Image_30,
            Image_31,
            Image_32,
            Image_33,
            Image_Obogrev_Morozilnikov,
            Image_MK,
            Image_Storage_Tank,
            Image_Pipes,
            Image_Clients_2,
            Image_Brands_2,
            Image_Clients_3,
            Image_Brands_3,
            NoImage,
        ];
    };
    return StaticAssets;
}());
exports.StaticAssets = StaticAssets;
